<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
    
        </p-toolbar>
        <p-table #miSurvey [value]="districtWise"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'District',
		'Block',
		'TotalApplication',
		'SubsidyPaid',
		'PendingEarly',
		'Pending_1Week',
		'Pending_Morethan_1Weeks',
		'AmountPaid',
		'MIArea',
        
        
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'DISTRICT_WISE_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">

            <tr>
              
                
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalApplication">{{'TOTAL_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="TotalApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="SubsidyPaid">{{'SUBSIDY_PAID'| translate}}
                    <p-columnFilter type="text" field="SubsidyPaid" display="menu"></p-columnFilter>
                    <p-sortIcon field="SubsidyPaid"></p-sortIcon>
                </th>
                <th pSortableColumn="PendingEarly">{{'PENDING_IN_TIME'| translate}}
                    <p-columnFilter type="text" field="PendingEarly" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingEarly"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_1Week">{{'PENDING_BY_ONE_WEEK'| translate}}
                    <p-columnFilter type="text" field="Pending_1Week" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_1Week"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_Morethan_1Weeks">{{'PENDING_MORE_THEN_ONE_WEEKS'| translate}}
                    <p-columnFilter type="text" field="Pending_Morethan_1Weeks" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Morethan_1Weeks"></p-sortIcon>
                </th>
                <th pSortableColumn="AmountPaid">{{'AMOUNT_PAID'| translate}}
                    <p-columnFilter type="text" field="AmountPaid" display="menu"></p-columnFilter>
                    <p-sortIcon field="AmountPaid"></p-sortIcon>
                </th>
                <th pSortableColumn="MIArea">{{'MI_AREA'| translate}}
                    <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="MIArea"></p-sortIcon>
                </th>
                
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-districtWise>
            <tr>
                <td>{{districtWise.District}}</td>
                <td>{{districtWise.Block}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_totalApp(districtWise.District,districtWise.Block)">{{districtWise.TotalApplication}}</a></td>
                <td>{{districtWise.SubsidyPaid}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(districtWise.District,'early',districtWise.Block)">{{districtWise.PendingEarly}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(districtWise.District,'1Week',districtWise.Block)">{{districtWise.Pending_1Week}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(districtWise.District,'morethan_1Week',districtWise.Block)">{{districtWise.Pending_Morethan_1Weeks}}</a></td>
                <td>{{districtWise.AmountPaid}}</td>
                <td>{{districtWise.MIArea}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td >{{totalApp | number:'1.0-2'}}</td>
                <td >{{subsidyPaid | number:'1.0-2'}}</td>
                <td >{{onTime | number:'1.0-2'}}</td>
                <td >{{pendingByWeek | number:'1.0-2'}}</td>
                <td >{{pendingMoreThanWeek | number:'1.0-2'}}</td>
                <td >{{amountPaid | number:'1.0-2'}}</td>
                <td >{{miArea | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td >{{grandTotalApp | number:'1.0-2'}}</td>
                <td >{{grandSubsidyPaid | number:'1.0-2'}}</td>
                <td >{{grandOnTime | number:'1.0-2'}}</td>
                <td >{{grandPendingByWeek | number:'1.0-2'}}</td>
                <td >{{grandPendingMoreThanWeek | number:'1.0-2'}}</td>
                <td >{{grandAmountPaid | number:'1.0-2'}}</td>
                <td >{{grandMiArea | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down District wise STV Report Of Total Application of {{value}} "  [(visible)]="displayMaximizable_totalApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-total-report  *ngIf="displayMaximizable_totalApp" [drilldownDetails]="drilldownDetails"></app-drill-down-total-report>
   
  </p-dialog> 
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down District wise STV Report Of {{pendingType}} Application of {{value}} "  [(visible)]="displayMaximizable_pendingApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-pending-report  *ngIf="displayMaximizable_pendingApp" [drilldownDetails]="drilldownDetails"></app-drill-down-pending-report>
   
  </p-dialog>
    
